export { default as CmsLargeAssetLeftHero } from './CmsLargeAssetLeftHero';
